<div *ngIf="eventDetails"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20 gap-4"
    (click)="$event.preventDefault(); closeDetails();"
>
    <div class="w-full max-w-screen-sm flex flex-row gap-1 justify-center" (click)="$event.stopPropagation()">
        <!-- EVENT DETAILS -->
        <div class="flex min-w-full bg-white p-10 w-1/4 rounded-md text-center shadow-lg">
            <div class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-row gap-8 items-center justify-between">
                    <h2 class="w-full oswald-font text-xl font-medium text-start whitespace-nowrap">
                        Report Details
                    </h2>
                    <div 
                        *ngIf="canSave()" 
                        class="w-full flex flex-row gap-2 items-center justify-end"
                    >
                        <div class="relative group">
                            <!-- Edit Button -->
                            <button
                                (click)="$event.preventDefault(); handleBtnClick('edit-event', eventDetails);"
                                class="flex items-center justify-center p-2 rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-100 to-nside-orange-200 oswald-font text-white"
                            >
                                <lucide-icon [name]="icons.Pencil" [size]="20"></lucide-icon>
                            </button>
                            <!-- Tooltip for Edit -->
                            <div 
                                class="absolute invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300 bg-nside-gray-400 text-white text-sm rounded-md px-2 py-1 left-1/2 transform -translate-x-1/2 mt-2 z-10 whitespace-nowrap"
                            >
                                Edit Event
                            </div>
                        </div>   
                        <div class="relative group">
                            <!-- Delete Button -->
                            <button
                                (click)="$event.preventDefault(); handleBtnClick('delete-confirmation', eventDetails, 'report');"
                                class="flex items-center justify-center p-2 rounded-md border border-nside-gray-300 bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 oswald-font text-white whitespace-nowrap"
                            >
                                <lucide-icon [name]="icons.Trash2" [size]="20"></lucide-icon>
                            </button>
                            <!-- Tooltip for Delete -->
                            <div 
                                class="absolute invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-300 bg-red-700 text-white text-sm rounded-md px-2 py-1 left-1/2 transform -translate-x-1/2 mt-2 z-10 whitespace-nowrap"
                            >
                                Delete Event
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full h-full flex flex-col items-center p-4 rounded-lg">
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Name:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ eventDetails.name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Type:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ eventDetails.type_name }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Date Time:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ eventDetails.start_date | date: 'MM/dd/yyyy' }} - {{ eventDetails.time }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Duration:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ eventDetails.duration }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-center text-start p-2 bg-gray-100">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Details:</p>
                        </div>
                        <div class="w-full flex items-center">
                            <p>{{ eventDetails.details }}</p>
                        </div>
                    </div>
                    <div class="w-full flex items-start text-start p-2">
                        <div class="w-44 flex items-center text-nside-gray-300">
                            <p>Files:</p>
                        </div>
                        <div class="w-full flex flex-col items-start justify-start gap-1">
                            <div *ngFor="let file of eventDetails.files" class="w-full flex item-center justify-between gap-1">
                                <button 
                                    class="mr-2 text-blue-500 hover:text-nside-orange-400 text-start"
                                    (click)="$event.preventDefault(); downloadFile(file);"
                                >
                                    {{ file.file_name }}
                                </button>
                                <button
                                    *ngIf="canSave()"
                                    class="h-8 w-8 flex items-center justify-center rounded-full hover:bg-gray-100"
                                    (click)="$event.preventDefault(); handleBtnClick('delete-confirmation', file, 'uploaded file');"
                                >
                                    <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                                </button>
                            </div>
                        </div> 
                    </div>
                </div>

                
                <div class="w-full flex flex-row gap-2 items-center justify-between">
                    <div class="min-w-10 flex gap-1 items-start justify-center">
                        <p class="oswald-font font-normal">
                            Last Updated At: <span class="raleway-font">{{ eventDetails.last_updated_at | date: 'MM/dd/yyyy - HH:mm' }}</span>
                        </p>
                        <p class="oswald-font font-normal">
                            By: <span class="raleway-font">{{ eventDetails.last_updated_user_name || 'None' }}</span>
                        </p>
                    </div>
                    <button 
                        (click)="$event.preventDefault(); closeDetails();"
                        class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
        
    </div>
</div>